<template>
  <div class="media-viewer" @click.self="$emit('close')">
    <div class="media-content">
      <button @click="$emit('close')" class="close-btn">
        <i class="fas fa-times"></i>
      </button>
      <img v-if="mediaType === 'image'" :src="mediaPath" class="media-display">
      <video v-else-if="mediaType === 'video'" controls autoplay class="media-display">
        <source :src="mediaPath" :type="getVideoMimeType(mediaPath)">
      </video>
      <audio v-else-if="mediaType === 'audio'" controls autoplay class="media-display">
        <source :src="mediaPath" :type="getAudioMimeType(mediaPath)">
      </audio>
      <div v-else-if="mediaType === 'document'" class="document-viewer">
        <i class="fas fa-file-alt"></i>
        <p>Document Preview Not Available</p>
        <el-button 
          type="primary" 
          :href="mediaPath" 
          target="_blank"
          class="download-btn"
        >
          <i class="fas fa-download"></i> Download Document
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    mediaPath: {
      type: String,
      required: true
    },
    mediaType: {
      type: String,
      required: true
    }
  },
  methods: {
    getVideoMimeType(path) {
      const ext = path.split('.').pop().toLowerCase();
      switch (ext) {
        case 'mp4': return 'video/mp4';
        case 'aac': return 'audio/aac';
        case 'mov': return 'video/quicktime';
        case 'm4a': return 'audio/mp4'; // M4A files use MP4 container with AAC audio
        case 'avi': return 'video/x-msvideo';
        default: return 'video/mp4';
      }
    },
    getAudioMimeType(path) {
      const ext = path.split('.').pop().toLowerCase();
      switch (ext) {
        case 'mp3': return 'audio/mpeg';
        case 'wav': return 'audio/wav';
        default: return 'audio/mpeg';
      }
    }
  }
};
</script>

<style scoped>
.media-viewer {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.9);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2000;
}

.media-content {
  position: relative;
  max-width: 90%;
  max-height: 90%;
}

.media-display {
  max-width: 100%;
  max-height: 80vh;
  display: block;
  margin: 0 auto;
}

.close-btn {
  position: absolute;
  top: -40px;
  right: 0;
  background: none;
  border: none;
  color: white;
  font-size: 24px;
  cursor: pointer;
}

.document-viewer {
  text-align: center;
  color: white;
  padding: 20px;
}

.document-viewer i {
  font-size: 5rem;
  margin-bottom: 20px;
  display: block;
}

.download-btn {
  margin-top: 20px;
}
</style>